export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/pinterest.0fe33a4.svg";